// Copy-to-clipboard for share buttons with [data-copy-link]

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-copy-link]')
  if (!buttons.length) return

  buttons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.copyLink
      const labelEl = btn.querySelector('[data-copy-label]')
      const original = labelEl ? labelEl.textContent : ''

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(url)
        } else {
          const ta = document.createElement('textarea')
          ta.value = url
          ta.style.position = 'fixed'
          ta.style.left = '-9999px'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }

        btn.classList.add('is-copied')
        if (labelEl) labelEl.textContent = '¡Copiado!'

        setTimeout(() => {
          btn.classList.remove('is-copied')
          if (labelEl) labelEl.textContent = original
        }, 1800)
      } catch (e) {
        console.error('Copy failed:', e)
      }
    })
  })
})
